import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { BsCardText } from "react-icons/bs";
import _ from "lodash";
import React, { Fragment, useContext, useEffect, useState } from "react";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import {
   Alert as Alert2, Button, ButtonGroup, Card, CardBody, Col,
   Input, Label, Modal, ModalBody, ModalFooter, ModalHeader,
   Row, Table,
} from "reactstrap";
import Select from "react-select";
import Switch from "react-switch";
import {
   FilterableScreen, FilterMultiSelect, FilterSet,
   FilterSwitch, FilterText, Pager, SortHeader,
} from "../components";
import { DesktopContainer } from "../layouts";
import { api, constants, dateHelpers, filterHelpers, UserContext } from "../utils";

const resolveRoleListDescription = (roles) => {
   return _.map(roles, (r) => constants.ROLE_DICTIONARY[r.typeOfUserRole]).join(
      ", "
   );
};

export default function Users() {
   const userCtx = useContext(UserContext);
   const [filters, setFilters] = useState([
      { filterName: "ActiveOnly", value: true, filteredDisplay: "Active Only" },
   ]);
   const [paginatedList, setPaginatedList] = useState({
      list: [],
      pageNumber: 1,
      totalPages: 1,
   });

   const [massNotifyPrompt, setMassNotifyPrompt] = useState("");
   const [message, setMessage] = useState(null);
   const [pageNumber, setPageNumber] = useState(1);
   const [printers, setPrinters] = useState([]);
   const [printToPrinter, setPrintToPrinter] = useState(true);
   const [selectedPrinter, setSelectedPrinter] = useState(null);
   const [selectedUserIds, setSelectedUserIds] = useState([]);
   const [sortDirection, setSortDirection] = useState("asc");
   const [sortField, setSortField] = useState("Username");
   const [textBody, setTextBody] = useState("");
   const [toggleSelectAll, setToggleSelectAll] = useState(false);
   const displayMe = false;  // To show or hide the print to PDF switch
   const handlePrint = nextChecked => { setPrintToPrinter(nextChecked); }
   const modalClassName = userCtx.theme ? `${userCtx.theme}` : "lightTheme";

   // eslint-disable-next-line react-hooks/exhaustive-deps
   useEffect(getPrinters, []);

   // eslint-disable-next-line react-hooks/exhaustive-deps
   useEffect(refreshData, [filters, pageNumber, sortField, sortDirection]);

   function createPayload() {
      let payload = {
         sortField: sortField,
         sortDirection: sortDirection,
         pageNumber: pageNumber,
      };
      _.map(filters, (filter) => (payload[filter.filterName] = filter.value));
      return payload;
   }

   function exportUserXLSX() {
      api
         .postGetBlob("UserAdmin/export", createPayload())
         .then((r) => {
            if (r.data) {
               const XLSX_FILENAME = `Users ${dateHelpers.toLongDateString(
                  dateHelpers.monthDayAndYear(Date.now())
               )}.xlsx`;
               if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                  window.navigator.msSaveOrOpenBlob(r.data, XLSX_FILENAME);
               } else {
                  const file = new Blob([r.data], {
                     type: constants.MIME_TYPES.xlsx,
                  });
                  var anchor = window.document.createElement("a");
                  anchor.download = XLSX_FILENAME;
                  anchor.href = (window.webkitURL || window.URL).createObjectURL(file);
                  anchor.dataset.downloadurl = [
                     constants.MIME_TYPES.xlsx,
                     anchor.download,
                     anchor.href,
                  ].join(":");
                  anchor.click();
               }
            } else {
               toast.error(r.message || "Error downloading report");
            }
         })
         .catch((error) => {
            if (_.isString(error)) {
               toast.error(error);
            }
         });
   }

   function formatPrinters(data) {
      // Do we need laser printers?
      let printerArr = _.concat(data.labels, data.lasers, data.parts);
      let list = _.map(printerArr, (x) => {
         return { label: x.nameOnly, value: x.id };
      });
      return list.sort((a, b) => (a.label.toLowerCase() > b.label.toLowerCase()) ? 1 : ((b.label.toLowerCase() > a.label.toLowerCase()) ? -1 : 0));
   }

   function getPrinters() {
      api
         .fetch("Printer/GetPrintersForDropdown")
         .then((response) => {
            if (response) {
               setPrinters(formatPrinters(response.data));
            } else {
               toast.error("Failed to get printers.");
            }
         })
         .catch(api.catchHandler);
   }

   function onDelete(selected) {
      confirmAlert({
         title: "Permanently Delete User",
         message: `This will permanently delete ${selected.firstName} ${selected.lastName}. Are you sure?`,
         buttons: [
            {
               label: "Ok",
               onClick: () => {
                  api
                     .post(`UserAdmin/DeleteUser/${selected.id}`)
                     .then((response) => {
                        if (response.data.success) {
                           refreshData();
                        } else {
                           setMessage({
                              flavor: "danger",
                              text: response?.data?.message,
                           });
                        }
                     })
                     .catch(api.catchHandler);
               },
            },
            {
               label: "Cancel",
            },
         ],
      });
   }

   function onFilterChange(changedFilter) {
      const filterChanges = filterHelpers.getFilters(filters, changedFilter);
      setFilters(filterChanges);
      setPageNumber(1);
   }

   function onImpersonate(u) {
      api
         .post("UserAdmin/Impersonate", { username: u.username })
         .then((response) => {
            if (response.data.success) {
               userCtx.impersonate(
                  response.data.user,
                  response.data.user.token,
                  response.data.menus
               );
            } else {
               setMessage({ flavor: "danger", text: response?.data?.message });
            }
         })
         .catch(api.catchHandler);
   }

   function onPrintLabel(u) {
      if (printToPrinter) {
         api
            .post("Report/RunUserLabelRpt", {
               Id: u.id,
               Name: selectedPrinter?.label || "",
               PrinterId: selectedPrinter?.value || 0,
               PrintToPrinter: printToPrinter
            })
            .then((response) => {
               if (response.data.success) {
                  toast.success("Label printed successfully");
               } else {
                  if (_.isString(response?.data?.message)) {
                     toast.error(response?.data?.message);
                  }
               }
            })
            .catch(() => toast.error("There was a failure printing the label"));
      }
      else {
         api
            .postDownloadBinary("Report/RunUserLabelRpt", {
               Id: u.id,
               Name: selectedPrinter?.label || "",
               PrinterId: selectedPrinter?.value || 0,
               PrintToPrinter: printToPrinter
            }, constants.MIME_TYPES.pdf, `${u.fullName}_Label.pdf`)
            .then((res) => {
               if (res?.data === false) {
                  toast.error(res.message);
               }
            })
            .catch(api.catchHandler);
      }
   }

   function onSendCustomNotification() {
      api
         .post("Admin/NotifyUsers", {
            userIds: selectedUserIds,
            textBody: textBody,
         })
         .then((response) => {
            if (response.data.success) {
               if (_.isString(response?.data?.message)) {
                  toast.success(response?.data?.message);
               }
               setMassNotifyPrompt("");
               setTextBody("");
            } else {
               if (_.isString(response?.data?.message)) {
                  toast.error(response?.data?.message);
               }
            }
         })
         .catch(() => toast.error("There was a failure sending"));
   }

   function onSortChange(field, direction) {
      setSortField(field);
      setSortDirection(direction);
   }

   function onToggleActive(selected) {
      api
         .post(`UserAdmin/ToggleUserActive/${selected.id}`)
         .then((response) => {
            if (response.data.success) {
               refreshData();
            } else {
               setMessage({ flavor: "danger", text: response?.data?.message });
            }
         })
         .catch(api.catchHandler);
   }

   function onToggleMustChangePassword(selected) {
      api
         .post(`UserAdmin/ToggleMustChangePassword/${selected.id}`)
         .then((response) => {
            if (response.data.success) {
               refreshData();
            } else {
               setMessage({ flavor: "danger", text: response?.data?.message });
            }
         })
         .catch(api.catchHandler);
   }

   function onToggleSelectAll(on) {
      setToggleSelectAll(on);
      setSelectedUserIds(on ? _.map(paginatedList.list, (x) => x.id) : []);
   }

   function onUnlockUser(selected) {
      api
         .post(`UserAdmin/UnlockUser/${selected.id}`)
         .then((response) => {
            if (response.data.success) {
               refreshData();
            } else {
               setMessage({ flavor: "danger", text: response?.data?.message });
            }
         })
         .catch(api.catchHandler);
   }

   function refreshData() {
      setMessage(null);
      api
         .post("UserAdmin/List", createPayload())
         .then((response) => {
            setSelectedUserIds([]);
            setPaginatedList(response.data);
         })
         .catch(api.catchHandler);
   }

   return (
      <DesktopContainer screenName={"Users"}>
         <FilterableScreen
            filters={
               <Row>
                  <Col xs="4">
                     <FilterSet filters={filters} clearFilters={() => setFilters([])}>
                        <Row>
                           <Col xs="3">
                              <FilterText
                                 filterName="Name"
                                 displayName="Name"
                                 value={filterHelpers.getValue(filters, "Name")}
                                 onChangeCallback={(e) => onFilterChange(e)}
                              />
                           </Col>
                           <Col xs="3" style={{ marginTop: "2rem" }}>
                              <FilterSwitch
                                 filterName="ActiveOnly"
                                 displayName="Active Only"
                                 value={filterHelpers.getValue(filters, "ActiveOnly")}
                                 onChangeCallback={(e) => onFilterChange(e)}
                              />
                           </Col>
                           <Col xs="3">
                              <FilterMultiSelect
                                 filterName="MemberOfRoles"
                                 displayName="Roles"
                                 values={filterHelpers.getValue(filters, "MemberOfRoles")}
                                 onChangeCallback={(e) => onFilterChange(e)}
                                 options={constants.ALL_ROLES}
                              />
                           </Col>
                        </Row>
                     </FilterSet>
                  </Col>
                  <Col xs="6" className="ps-0 pe-4">
                     <Row>
                        <Col xs="1" style={{ textAlign: "left", marginRight: "5px" }}>
                           Printers:
                        </Col>
                        <Col xs="5">
                           <Select
                              classNamePrefix="serviceThreadSelect"
                              options={printers}
                              value={selectedPrinter}
                              onChange={(e) => setSelectedPrinter(e)}
                              isMulti={false}
                              isClearable={false}
                           />
                        </Col>
                        <Col>
                           {displayMe ? (
                              <Switch
                                 onChange={handlePrint}
                                 checked={printToPrinter}
                                 className="react-switch"
                              />
                           ) : null}
                        </Col>
                     </Row>
                  </Col>
                  <Col xs="2" className="ps-0 pe-4">
                     {userCtx?.currentUser?.isAdmin ? (
                        <ButtonGroup style={{ float: "right" }}>
                           <Button
                              style={{ backgroundColor: "#03a138" }}
                              className="projectSuccess"
                              tag={Link}
                              to="0"
                              title="Add"
                           >
                              <FontAwesomeIcon icon="plus" />
                           </Button>
                           <Button
                              style={{ backgroundColor: "#007bff" }}
                              onClick={exportUserXLSX}
                              title="Export Users"
                           >
                              <FontAwesomeIcon icon="download" /> Export
                           </Button>
                        </ButtonGroup>
                     ) : null}
                  </Col>
               </Row>
            }
            pager={
               <div className="float-start">
                  <Pager
                     pageNumber={paginatedList?.pageNumber ? paginatedList.pageNumber : 0}
                     totalPages={paginatedList?.totalPages ? paginatedList.totalPages : 0}
                     callBack={(newPageNumber) => setPageNumber(newPageNumber)}
                  />
               </div>
            }
         >
            <Card>
               <CardBody>
                  <Row className="p-0 m-0">
                     <Col xs="12">
                        {message ? (
                           <Alert2 className={message.flavor}>{message.text}</Alert2>
                        ) : null}
                        <Table size="sm" responsive={false} id="userTable">
                           <thead>
                              <tr>
                                 <th width="40px">
                                    <input
                                       type="checkbox"
                                       checked={toggleSelectAll}
                                       onChange={(e) => onToggleSelectAll(e.target.checked)}
                                    />
                                 </th>
                                 <th width="40px"></th>
                                 <th>
                                    <SortHeader
                                       displayName="Name / Username"
                                       field="Username"
                                       sortDirection={sortDirection}
                                       sorted={sortField === "Username"}
                                       callback={onSortChange}
                                    />
                                 </th>
                                 <th>
                                    <SortHeader
                                       displayName="Contact"
                                       field="Contact"
                                       sortDirection={sortDirection}
                                       sorted={sortField === "Contact"}
                                       callback={onSortChange}
                                    />
                                 </th>
                                 <th style={{ width: "40%" }}>Roles</th>
                                 <th></th>
                                 <th width="20%">
                                    <SortHeader
                                       displayName="Info"
                                       field="LastLogon"
                                       sortDirection={sortDirection}
                                       sorted={sortField === "LastLogon"}
                                       callback={onSortChange}
                                    />
                                 </th>
                                 <th width="20%"></th>
                              </tr>
                           </thead>
                           <tbody>
                              {_.map(paginatedList.list, (u, index) => (
                                 <tr key={`u-${u.id}`} className={`tr-${index % 2 === 0 ? "primary" : "secondary"}`}>
                                    <td width="40px">
                                       <input
                                          type="checkbox"
                                          checked={selectedUserIds.includes(u.id)}
                                          onChange={(e) => {
                                             if (e.target.checked) {
                                                let newIdList = selectedUserIds.slice();
                                                newIdList.push(u.id);
                                                setSelectedUserIds(newIdList);
                                             } else {
                                                setSelectedUserIds(_.reject(selectedUserIds, (x) => x === u.id));
                                             }
                                          }}
                                       />
                                    </td>
                                    <td>
                                       {u.roleTypeIdList.includes(constants.ROLE_IDS.ADMIN) ||
                                          u.roleTypeIdList.includes(constants.ROLE_IDS.SYSADMIN) ? (
                                          <span className="text-success" title="Administrator">
                                             <FontAwesomeIcon icon="user" />
                                          </span>
                                       ) : null}
                                    </td>
                                    <td>
                                       {u.deactivatedAt ? (
                                          `${u.firstName} ${u.lastName}`
                                       ) : (
                                          <Link to={`/admin/users/${u.id}`}>
                                             {u.firstName} {u.lastName}
                                          </Link>
                                       )}
                                       <div style={{ fontStyle: "italic", fontWeight: "bold" }}>
                                          {u.username}
                                       </div>
                                    </td>
                                    <td>{u.mobilePhoneNumber}</td>
                                    <td>{resolveRoleListDescription(u.roles)}</td>
                                    <td>
                                       {u.mustChangePassword ? (
                                          <span
                                             className="text-warning clickable-icon"
                                             title="Must change password! - click to remove this requirement"
                                             onClick={() => onToggleMustChangePassword(u)}
                                          >
                                             <FontAwesomeIcon size="2x" icon="exclamation-triangle" />
                                          </span>
                                       ) : null}
                                       {u.isLockedOut ? (
                                          <span
                                             className={"clickable-icon text-danger"}
                                             title="Currently locked out - click to unlock"
                                             onClick={() => onUnlockUser(u)}
                                          >
                                             <FontAwesomeIcon size="2x" icon="unlock-alt" />
                                          </span>
                                       ) : null}
                                    </td>
                                    <td>
                                       <div>
                                          Last Logged On:{" "}
                                          <span style={{ fontStyle: "italic" }}>
                                             {u.lastLoggedOn ? u.lastLoggedOn : "Never"}
                                          </span>
                                       </div>
                                    </td>
                                    <td>
                                       <ButtonGroup className="float-end">
                                          <Button
                                             size="sm"
                                             title="Impersonate"
                                             className="btn-dark"
                                             onClick={() => onImpersonate(u)}
                                             disabled={u.deactivatedAt}
                                          >
                                             <FontAwesomeIcon icon="mask" />
                                          </Button>
                                          <span
                                             className="d-inline-flex"
                                             title={u.isBadgeEligible ? "Print Login Label" : "Badge login is only available to sole machine-operator accounts"}
                                          >
                                             <Button
                                                size="sm"
                                                className="btn-dark qr-button"
                                                onClick={() => onPrintLabel(u)}
                                                disabled={u.deactivatedAt || !u.isBadgeEligible}
                                             >
                                                <BsCardText />
                                             </Button>
                                          </span>
                                          {u.mustChangePassword ? null : (
                                             <Button
                                                className="text-warning"
                                                title="Click to both force change of password and send a link to enable setting to a fresh value."
                                                onClick={() => onToggleMustChangePassword(u)}
                                                disabled={u.deactivatedAt}
                                             >
                                                <FontAwesomeIcon icon="exclamation-triangle" />
                                             </Button>
                                          )}
                                          {u.deactivatedAt ? (
                                             <Button
                                                size="sm"
                                                className="btn-light"
                                                title="Revive"
                                                onClick={() => onToggleActive(u)}
                                             >
                                                <FontAwesomeIcon icon="recycle" />
                                             </Button>
                                          ) : (
                                             <Fragment>
                                                <Button
                                                   style={{ backgroundColor: "#ecd44c" }}
                                                   size="sm"
                                                   className="projectWarning"
                                                   title="Deactivate"
                                                   onClick={() => onToggleActive(u)}
                                                >
                                                   <FontAwesomeIcon icon="times-circle" />
                                                </Button>
                                                <Button
                                                   style={{ backgroundColor: "red" }}
                                                   size="sm"
                                                   className="projectDanger"
                                                   title="Delete Permanently"
                                                   onClick={() => onDelete(u)}
                                                >
                                                   <FontAwesomeIcon icon="times-circle" />
                                                </Button>
                                             </Fragment>
                                          )}
                                       </ButtonGroup>
                                    </td>
                                 </tr>
                              ))}
                           </tbody>
                        </Table>
                     </Col>
                  </Row>

                  {massNotifyPrompt ? (
                     <Modal isOpen={true} toggle={() => setMassNotifyPrompt("")} contentClassName={modalClassName}>
                        <ModalHeader className="primary">
                           <FontAwesomeIcon icon="mail-bulk" /> {massNotifyPrompt}
                        </ModalHeader>
                        <ModalBody>
                           <Label>Type your message here:</Label>
                           <Input
                              className="serviceThreadTextArea"
                              type="textarea"
                              value={textBody}
                              onChange={(e) => setTextBody(e.target.value)}
                           />
                        </ModalBody>
                        <ModalFooter className="float-end">
                           <ButtonGroup>
                              <Button
                                 size="sm"
                                 className="button-primary"
                                 onClick={onSendCustomNotification}
                              >
                                 Send
                              </Button>
                              <Button
                                 size="sm"
                                 className="button-secondary"
                                 onClick={() => setMassNotifyPrompt("")}
                              >
                                 Cancel
                              </Button>
                           </ButtonGroup>
                        </ModalFooter>
                     </Modal>
                  ) : null}
               </CardBody>
            </Card>
         </FilterableScreen>
      </DesktopContainer>
   );
}
